import { cx } from "@linaria/core";
import { useCallback, useState } from "react";
import { NextPage } from "next";
import { META_CATALOG } from "@/components/Meta/constants";
import { Meta } from "@/components/Meta/Meta";
import { ListMap } from "@/components/Shops/ListMap";
import { cssButtonToggle, cssModeList, cssModeMap, StyledStoresWrapper } from "@/components/Shops/StyledStoresPage";
import { StaticTemplate } from "@/layouts/Static/StaticTemplate";
import { Button } from "@/ui/Button/Button";
import { TITLE_SITE_RU } from "@/utils/constants";
const META_TITLE = `Магазины - ${TITLE_SITE_RU}`;
const META_DESCRIPTION = `Магазины «${TITLE_SITE_RU}» ${META_CATALOG.partDescriptionEnd}`;
const StoresPage: NextPage = () => {
  const [mode, setMode] = useState<"map" | "list">("list");
  const modeToggle = useCallback(() => {
    if (mode === "map") {
      setMode("list");
    }
    if (mode === "list") {
      setMode("map");
    }
  }, [mode]);
  return <>
      <Meta title={META_TITLE} description={META_DESCRIPTION} />
      <StaticTemplate title={"Магазины"}>
        <Button icon={mode === "map" ? "ListBullet" : "Location"} variant={"link"} onClick={modeToggle} className={cssButtonToggle}>
          {mode === "map" && "Списком"}
          {mode === "list" && "На карте"}
        </Button>
        <StyledStoresWrapper className={cx(mode === "map" && cssModeMap, mode === "list" && cssModeList)}>
          <ListMap withRouteToDetail />
        </StyledStoresWrapper>
      </StaticTemplate>
    </>;
};
export default StoresPage;